import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import classNames from 'classnames';
import {get} from 'lodash';

type ConditionDraft = {
	field: string;
	values: any[];
}

type ConditionalNoteProps = {
	htmlText: string;
	isCentered?: boolean;
	conditions: ConditionDraft[];
}
export default ({htmlText, isCentered, conditions = []}: ConditionalNoteProps) => {
	const {getValues, watch} = useFormContext();
	const isValid = conditions.every(({field, values}) => {
		const currentValue = get(getValues(), field);
		return values.includes(currentValue);
	});

	watch(conditions.map(({field}) => field));

	return isValid
		? (
			<div
				className={classNames(styles.note, isCentered && styles.isCentered)}
				dangerouslySetInnerHTML={{__html: htmlText}}
			>
			</div>
		)
		: null
}
